import { render, staticRenderFns } from "./classificationAdmin.vue?vue&type=template&id=2bdbc42e&scoped=true&"
import script from "./classificationAdmin.vue?vue&type=script&lang=js&"
export * from "./classificationAdmin.vue?vue&type=script&lang=js&"
import style0 from "./classificationAdmin.vue?vue&type=style&index=0&id=2bdbc42e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdbc42e",
  null
  
)

export default component.exports